export const messages = {
  en: {
    viewOwnerInfo: {
      title: 'Owner Information',
      ownerId: 'Owner ID',
      name: 'Name',
      sex: 'Gender',
      age: 'Age',
      idCard: 'ID Card',
      link: 'Contact',
      userName: 'Created By',
      remark: 'Remark',
      chooseOwner: 'Select Owner',
      loadError: 'Failed to load owner information'
    },
    showOwnerRoom: {
      info: 'Room Information',
      propertyFee: 'Property Fee',
      exitRoom: 'I want to exit the room',
      shopNum: 'Shop Number',
      roomNum: 'Room Number',
      floor: 'Floor',
      shopId: 'Shop ID',
      roomId: 'Room ID',
      builtUpArea: 'Built-up Area',
      squareMeters: 'Square Meters',
      apartmentLayout: 'Apartment Layout',
      roomCount: 'Number of Rooms',
      layer: 'layer'
    },
    ownerExitRoom: {
      confirmOperation: 'Please confirm your operation',
      confirmExit: 'Confirm to exit the room?',
      confirmExitTip: 'After exiting, it can be sold again',
      cancel: 'Cancel',
      confirmExitBtn: 'Confirm Exit'
    }
  },
  zh: {
    viewOwnerInfo: {
      title: '业主信息',
      ownerId: '业主ID',
      name: '名称',
      sex: '性别',
      age: '年龄',
      idCard: '身份证',
      link: '联系方式',
      userName: '创建员工',
      remark: '备注',
      chooseOwner: '选择业主',
      loadError: '加载业主信息失败'
    },
    showOwnerRoom: {
      info: '房屋信息',
      propertyFee: '物业费',
      exitRoom: '我要退房',
      shopNum: '商铺编号',
      roomNum: '房屋编号',
      floor: '楼层',
      shopId: '商铺ID',
      roomId: '房屋ID',
      builtUpArea: '建筑面积',
      squareMeters: '平方米',
      apartmentLayout: '户型',
      roomCount: '房间数',
      layer: '层'
    },
    ownerExitRoom: {
      confirmOperation: '请确认您的操作',
      confirmExit: '确认是否退房？',
      confirmExitTip: '退房后可以再次售卖',
      cancel: '点错了',
confirmExitBtn: '确认退出'
    }
  },
  'zh-TW': {
    viewOwnerInfo: {
      title: '業主信息',
      ownerId: '業主ID',
      name: '名稱',
      sex: '性別',
      age: '年齡',
      idCard: '身份證',
      link: '聯繫方式',
      userName: '創建員工',
      remark: '備註',
      chooseOwner: '選擇業主',
      loadError: '載入業主信息失敗'
    },
    showOwnerRoom: {
      info: '房屋信息',
      propertyFee: '物业費',
      exitRoom: '我要退房',
      shopNum: '商鋪編號',
      roomNum: '房屋編號',
      floor: '樓層',
      shopId: '商鋪ID',
      roomId: '房屋ID',
      builtUpArea: '建築面積',
      squareMeters: '平方米',
      apartmentLayout: '戶型',
      roomCount: '房間數',
      layer: '層'
    },
    ownerExitRoom: {
      confirmOperation: '請確認您的操作',
      confirmExit: '確認是否退房？',
      confirmExitTip: '退房後可以再次售賣',
      cancel: '點錯了',
      confirmExitBtn: '確認退出'
    }
  }
}